/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { createTheme } from '@mui/material/styles';
import { PROMETHEAN_NEUTRAL_LIGHT_GREY, PROMETHEAN_NEUTRAL_PLUM, PROMETHEAN_NEUTRAL_WHITE, PROMETHEAN_BLUE, PROMETHEAN_PURPLE_GRAPE } from '../../../styles/colors/colors';
export var embersTableBodyTheme = createTheme({
  components: {
    MuiTableRow: {
      styleOverrides: {
        root: {
          backgroundColor: PROMETHEAN_NEUTRAL_WHITE,
          '&:nth-of-type(even)': {
            backgroundColor: PROMETHEAN_NEUTRAL_LIGHT_GREY
          },
          '&.Mui-selected': {
            backgroundColor: PROMETHEAN_NEUTRAL_PLUM,
            '&:hover': {
              backgroundColor: "".concat(PROMETHEAN_NEUTRAL_PLUM, " !important")
            }
          },
          '&.EmbersTable-row-clickable': {
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: "".concat(PROMETHEAN_NEUTRAL_PLUM, " !important"),
              boxShadow: "inset 4px 0 ".concat(PROMETHEAN_PURPLE_GRAPE)
            },
            '&.EmbersTable-row-tooltip-hover': {
              backgroundColor: "".concat(PROMETHEAN_NEUTRAL_PLUM, " !important"),
              boxShadow: "inset 4px 0 ".concat(PROMETHEAN_PURPLE_GRAPE)
            },
            '&.Embers-focusVisible': {
              'td:not(.fixed-checkbox)': {
                boxShadow: "inset 0px -2px 0px 0px ".concat(PROMETHEAN_BLUE, ", inset 0px 2px 0px 0px ").concat(PROMETHEAN_BLUE),
                '&:last-child': {
                  boxShadow: "inset 0px -2px 0px 0px ".concat(PROMETHEAN_BLUE, ", inset 0px 2px 0px 0px ").concat(PROMETHEAN_BLUE, ", inset -2px 0px 0px 0px ").concat(PROMETHEAN_BLUE)
                },
                '&[tabindex="0"]': {
                  boxShadow: "inset 0px -2px 0px 0px ".concat(PROMETHEAN_BLUE, ", inset 0px 2px 0px 0px ").concat(PROMETHEAN_BLUE, ", inset 2px 0px 0px 0px ").concat(PROMETHEAN_BLUE)
                }
              }
            }
          },
          '&.EmbersTable-row-disabled': {
            '&:hover': {
              backgroundColor: "".concat(PROMETHEAN_NEUTRAL_WHITE, " !important")
            },
            '&:hover:nth-of-type(even)': {
              backgroundColor: "".concat(PROMETHEAN_NEUTRAL_LIGHT_GREY, " !important")
            }
          }
        }
      }
    }
  }
});